import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ed7d84e6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ed7d84e6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7d84e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed7d84e6')) {
      api.createRecord('ed7d84e6', component.options)
    } else {
      api.reload('ed7d84e6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ed7d84e6&scoped=true", function () {
      api.rerender('ed7d84e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/ezpay/components/LangSelect/index.vue"
export default component.exports